export const selectIsLogedIn = (state) => state.auth.isLogedIn;
export const selectUser = (state) => state.auth.user;
export const selectIsRefreshing = (state) => state.auth.isRefreshing;
